export type MaterialID = string; // materialID
export type DoorFrameMaterial = string; // frameID
export enum DoorMaterialDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
